import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { generate as id } from "short-uuid"
import CourseCard from "../CourseCard/CourseCard"
import CourseRow from "../CourseRow/CourseRow"
import { CardContainer } from "./styles"

const Courses = () => {
  const data = useStaticQuery(graphql`
    query {
      allDatoCmsCourse(
        sort: { fields: [ordertorender], order: ASC }
        filter: { tag: { eq: "course" } }
      ) {
        nodes {
          title
          image {
            fluid {
              ...GatsbyDatoCmsFluid
            }
          }
          description
          coupon
          linkwithcoupon
          linkpaid
          price
          typeofcourse
          ordertorender
          deadline
        }
      }
    }
  `)

  console.log(data)

  const coursesPremium = data.allDatoCmsCourse.nodes.filter(
    course => course.typeofcourse === "course-premium"
  )
  const coursesSemiPremium = data.allDatoCmsCourse.nodes.filter(
    course => course.typeofcourse === "course-semi-premium"
  )
  const coursesFree = data.allDatoCmsCourse.nodes.filter(
    course => course.typeofcourse === "course-free"
  )
  return (
    <>
      <CourseRow title="Premium" countdown="true">
        <CardContainer>
          {coursesPremium.map(course => (
            <CourseCard
              key={id()}
              title={course.title}
              image={course.image.fluid.srcSet}
              description={course.description}
              coupon={course.coupon}
              linkWithCoupon={course.linkwithcoupon}
              linkPaid={course.linkpaid}
              price={course.price}
              typeOfCourse={course.typeofcourse}
              deadline={course.deadline}
            />
          ))}
        </CardContainer>
      </CourseRow>
      <CourseRow title="Semi Premium" countdown="true">
        <CardContainer>
          {coursesSemiPremium.map(course => (
            <CourseCard
              key={id()}
              title={course.title}
              image={course.image.fluid.srcSet}
              description={course.description}
              coupon={course.coupon}
              linkWithCoupon={course.linkwithcoupon}
              linkPaid={course.linkpaid}
              price={course.price}
              typeOfCourse={course.typeofcourse}
              deadline={course.deadline}
            />
          ))}
        </CardContainer>
      </CourseRow>
      <CourseRow title="FREE">
        <CardContainer>
          {coursesFree.map(course => (
            <CourseCard
              key={id()}
              title={course.title}
              image={course.image.fluid.srcSet}
              description={course.description}
              coupon={course.coupon}
              linkWithCoupon={course.linkwithcoupon}
              linkPaid={course.linkpaid}
              price={course.price}
              typeOfCourse={course.typeofcourse}
            />
          ))}
        </CardContainer>
      </CourseRow>
    </>
  )
}

export default Courses
